import {writable} from 'svelte/store';
import type {components} from '../api/types';

export type NewPresentationOptions =
    components['schemas']['NewPresentationOptions'];
export const newPresentationOptions = writable<NewPresentationOptions>({
    generators: [
        {
            label: 'DALL·E 2',
            value: 'dalle-2',
        },
        {
            label: 'Bing Search',
            value: 'bing-search',
        },
        {
            label: 'Stable Diffusion',
            value: 'stable-diffusion',
        },
    ],
    languages: [
        {
            label: 'English',
            value: 'en',
        },
        {
            label: 'Deutsch',
            value: 'de',
        },
    ],
    speakers: [
        {
            label: 'Joanna (US)',
            value: 'Joanna',
        },
        {
            value: 'Salli',
            label: 'Salli (US)'
        },
        {
            value: 'Kendra',
            label: 'Kendra (US)'
        },
        {
            value: 'Ivy',
            label: 'Ivy (US)'
        },
        {
            value: 'Kimberly',
            label: 'Kimberly (US)'
        },
        {
            value: 'Kevin',
            label: 'Kevin (US)'
        },
        {
            value: 'Matthew',
            label: 'Matthew (US)'
        },
        {
            value: 'Justin',
            label: 'Justin (US)'
        },
        {
            value: 'Joey',
            label: 'Joey (US)'
        },
        {
            value: 'Vicki',
            label: 'Vicki (DE)'
        },
        {
            value: 'Hannah',
            label: 'Hannah (AT)'
        },
        {
            value: 'Lea',
            label: 'Léa (FR)'
        },
        {
            value: 'Bianca',
            label: 'Bianca (IT)'
        },
        {
            value: 'Takumi',
            label: 'Takumi (JP)'
        },
        {
            value: 'Lupe',
            label: 'Lupe (ES)'
        },
        {
            value: 'Thomas',
            label: 'Thomas (US)'
        },
        {
            value: 'Thomas (Video)',
            label: 'Thomas (US, Video)'
        },
        {
            value: 'Jonas',
            label: 'Jonas (US)'
        },
        {
            value: 'Jonas (Video)',
            label: 'Jonas (US, Video)'
        },
        {
            value: 'Jonas ASMR',
            label: 'Jonas ASMR (US)'
        },
        {
            value: 'Jonas ASMR (Video)',
            label: 'Jonas ASMR (US, Video)'
        }
    ],
    textGenerators: [
        {
            label: 'Open AI GPT3',
            value: 'openai-gpt3',
        },
        {
            label: 'Open AI GPT4',
            value: 'openai-gpt4',
        },
        {
            label: 'Aleph Alpha',
            value: 'aleph-alpha',
        },
    ],
    slides: [
        {
            value: '3',
            label: '3 Slides',
        },
        {
            value: '5',
            label: '5 Slides',
        },
        {
            value: '10',
            label: '10 Slides',
        },
    ],
});
